import { DocumentType } from '@synergy/models';

import { ConverterJob } from '../models/internal/converterJob';
import { ConverterPositionItem } from '../models/internal/converter-positionItem';
import { Inquiry } from '../../inquiries/models/inquiry';
import { TransitionTarget } from '../models/internal/transition-target';
import { getPriceCalculation } from '../../inquiries/utils/get-price-calculation';

/**
 * Builds the follow-up document from an inquiry, with nothing ticked: the
 * buyer picks a supplier per position. The best bidder used to be ticked as a
 * proposal (#2214, R-53); the customer asked for the choice instead (R-222).
 * The "Bestbieter" badge still says which one it is.
 */
export const createConverterJobFromInquiry = (inquiry: Inquiry): ConverterJob => {
    const source: ConverterJob = {
        source: inquiry,
        possibleTargets: [TransitionTarget.PurchaseOrder],
        selectedTarget: TransitionTarget.PurchaseOrder,
        selectedCustomerId: -1,
        documentType: DocumentType.Inquiry,
        supportsDeliveryCosts: true,
        hasDeliveryDate: false,
        customers: inquiry.accountPurchases.map(accountPurchase => {
            const bestOfferId = getPriceCalculation(accountPurchase.offers).bestOfferId;

            return {
                id: accountPurchase.id || 0,
                name: accountPurchase.customerAccount.name,
                isLocked: accountPurchase.customerAccount.isLocked,
                deliveryAddress: accountPurchase.deliveryAddress,
                customerSuppliers:
                    (accountPurchase.offers &&
                        accountPurchase.offers
                            .filter(offer =>
                                offer.offerItems.some(offerItem => offerItem.isOffered || offerItem.isAlternative)
                            )
                            .map(offer => ({
                                id: offer.id,
                                name: offer.supplierAccount.name,
                                isLocked: offer.supplierAccount.isLocked,
                                isBestOffer: offer.id === bestOfferId,
                                deliveryPrice: offer.deliveryPrice,
                                surcharge: offer.surcharge,
                                items: offer.offerItems.map(offerItem => {
                                    const item = ConverterPositionItem.fromPlainObject(offerItem);
                                    item.secondaryText =
                                        (offerItem.isAlternative && offerItem.alternativeNote) || undefined;
                                    item.isSelected = false;

                                    return item;
                                }),
                            }))) ||
                    [],
            };
        }),
    };
    return ConverterJob.fromPlainObject(source);
};
